export default __webpack_public_path__ + "static/unicorn-lego-man-ecdb2fc14796397c5d4a178a41bcdd9f.jpg";